import { BillingCycle, MemberType } from "@/enums/mateEnums";

export interface MemberPlanBenefit {
  text: string;
  icon: string;
  count?: number;
  value?: number;
  valueUnit?: string;
  type?: "end" | "value";
}

export interface MemberPlan {
  name: string;
  total: number;
  received: number;
  prices: {
    id: number;
    type: string;
    price: number;
    tag: string;
    billingCycle: BillingCycle;
  }[];
  benefits: MemberPlanBenefit[];
}

export const originPlanData: Record<
  MemberType.Standard | MemberType.Premium | MemberType.Basic,
  MemberPlan
> = {
  [MemberType.Basic]: {
    name: "小镇规划师",
    total: 120,
    received: 30,
    prices: [
      {
        id: 7,
        type: "连续包月",
        price: 12,
        tag: "超值首选",
        billingCycle: BillingCycle.Month,
      },
      {
        id: 8,
        type: "连续包季",
        price: 36,
        tag: "",
        billingCycle: BillingCycle.Quarter,
      },
      {
        id: 9,
        type: "连续包年",
        price: 120,
        tag: "最划算",
        billingCycle: BillingCycle.Year,
      },
    ],
    benefits: [
      {
        text: "立即获得",
        icon: "check",
        value: 30,
        valueUnit: "power",
        type: "end",
      },
      {
        text: "会员期间额外领取每日奖励，共计",
        icon: "check",
        value: 90,
        valueUnit: "power",
        type: "end",
      },
      {
        text: "云存储空间2GB",
        icon: "check",
      },
      {
        text: "小镇规划师身份标识",
        icon: "check",
      },
      {
        text: "免费使用入门模型，不消耗能量块",
        icon: "star",
      },
    ],
  },
  [MemberType.Standard]: {
    name: "行星构筑师",
    total: 500,
    received: 200,
    prices: [
      {
        id: 1,
        type: "连续包月",
        price: 34.9,
        tag: "超值首选",
        billingCycle: BillingCycle.Month,
      },
      {
        id: 2,
        type: "连续包季",
        price: 99,
        tag: "",
        billingCycle: BillingCycle.Quarter,
      },
      {
        id: 3,
        type: "连续包年",
        price: 349,
        tag: "最划算",
        billingCycle: BillingCycle.Year,
      },
    ],
    benefits: [
      // {
      //   text: "会员期间每月可计获得",
      //   icon: "check",
      //   value: 500,
      //   valueUnit: "power",
      //   type: "end",
      // },
      {
        text: "立即获得",
        icon: "check",
        value: 200,
        valueUnit: "power",
        type: "end",
      },
      {
        text: "会员期间额外领取每日奖励，共计",
        icon: "check",
        value: 300,
        valueUnit: "power",
        type: "end",
      },
      { text: "人物设定与记忆自动同步", icon: "check" },
      {
        text: "简单模式生成角色额度*1",
        icon: "check",
        value: 50,
        valueUnit: "power",
      },
      { text: "云存储空间5GB", icon: "check" },
      { text: "行星构筑师身份标识", icon: "check" },
      { text: "免费使用入门、轻享模型，不消耗能量块", icon: "star" },
    ],
  },
  [MemberType.Premium]: {
    name: "星系幻想家",
    total: 1600,
    received: 600,
    prices: [
      {
        id: 4,
        type: "连续包月",
        price: 99,
        tag: "超值首选",
        billingCycle: BillingCycle.Month,
      },
      {
        id: 5,
        type: "连续包季",
        price: 279,
        tag: "",
        billingCycle: BillingCycle.Quarter,
      },
      {
        id: 6,
        type: "连续包年",
        price: 999,
        tag: "最划算",
        billingCycle: BillingCycle.Year,
      },
    ],
    benefits: [
      // {
      //   text: "会员期间每月可计获得",
      //   icon: "check",
      //   value: 1600,
      //   valueUnit: "power",
      //   type: "end",
      // },
      {
        text: "立即获得",
        icon: "check",
        value: 600,
        valueUnit: "power",
        type: "end",
      },
      {
        text: "会员期间额外领取每日奖励，共计",
        icon: "check",
        value: 1000,
        valueUnit: "power",
        type: "end",
      },
      {
        text: "简单模式生成角色额度*5",
        icon: "check",
        value: 250,
        valueUnit: "power",
      },
      { text: "云存储空间100GB", icon: "check" },
      { text: "星系幻想家身份标识", icon: "star" },
      { text: "免费使用入门、轻享、标准模型，不消耗能量块", icon: "star" },
      // {
      //   text: "免费更换小屋皮肤",
      //   icon: "star",
      //   value: 30,
      //   valueUnit: "crystal",
      // },
      {
        text: "设定与记忆同步，开放所有记忆卡槽",
        icon: "star",
        value: 90,
        valueUnit: "crystal",
      },
    ],
  },
};

export const originMemberData: Record<
  MemberType.Standard | MemberType.Premium | MemberType.Basic,
  Record<string, MemberPlanBenefit[]>
> = {
  [MemberType.Basic]: {
    benefits: [
      // {
      //   text: "现在续费立即获得",
      //   icon: "check",
      //   value: 30,
      //   valueUnit: "power",
      //   type: "end",
      // },
      {
        text: "会员期间额外领取每日奖励，共计",
        icon: "check",
        value: 90,
        valueUnit: "power",
        type: "end",
      },
      { text: "人物设定与记忆自动同步", icon: "check" },
      { text: "云存储空间2GB", icon: "check" },
      { text: "小镇规划师身份标识", icon: "check" },
      { text: "免费使用入门模型，不消耗能量块", icon: "star" },
    ],
  },

  [MemberType.Standard]: {
    benefits: [
      // {
      //   text: "现在续费立即获得",
      //   icon: "check",
      //   value: 200,
      //   valueUnit: "power",
      //   type: "end",
      // },
      {
        text: "会员期间额外领取每日奖励，共计",
        icon: "check",
        value: 300,
        valueUnit: "power",
        type: "end",
      },
      { text: "人物设定与记忆自动同步", icon: "check" },
      {
        text: "简单模式生成角色额度*1",
        icon: "check",
        value: 50,
        valueUnit: "power",
      },
      { text: "云存储空间5GB", icon: "check" },
      { text: "行星构筑师身份标识", icon: "check" },
      { text: "免费使用入门、轻享模型，不消耗能量块", icon: "star" },
    ],
  },
  [MemberType.Premium]: {
    benefits: [
      // {
      //   text: "现在续费立即获得",
      //   icon: "check",
      //   value: 600,
      //   valueUnit: "power",
      //   type: "end",
      // },
      {
        text: "会员期间额外领取每日奖励，共计",
        icon: "check",
        value: 1000,
        valueUnit: "power",
        type: "end",
      },
      { text: "人物设定与记忆自动同步", icon: "check" },
      {
        text: "简单模式生成角色额度*5",
        icon: "check",
        value: 250,
        valueUnit: "power",
      },
      { text: "云存储空间100GB", icon: "check" },
      { text: "星系幻想家身份标识", icon: "check" },
      { text: "免费使用入门、轻享、标准模型，不消耗能量块", icon: "star" },
      // {
      //   text: "免费更换小屋皮肤",
      //   icon: "star",
      //   value: 30,
      //   valueUnit: "crystal",
      // },
      {
        text: "设定与记忆同步，开放所有记忆卡槽",
        icon: "star",
        value: 90,
        valueUnit: "crystal",
      },
    ],
  },
};

export const getMemberTypeByPlanId = (planId: number) => {
  if ([1, 2, 3].includes(planId)) {
    return MemberType.Standard;
  } else if ([4, 5, 6].includes(planId)) {
    return MemberType.Premium;
  } else if ([7, 8, 9].includes(planId)) {
    return MemberType.Basic;
  }
};
